export const constructionSiteAnalysisQueryKeys = {
	all: ["constructionSiteAnalysis"] as const,

	analysisData: (constructionSiteId: number) =>
		[
			...constructionSiteAnalysisQueryKeys.all,
			"analysisData",
			constructionSiteId,
		] as const,
};
